import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import CharityIssueCategoriesPage from "./charity-issue-categories-page";
import CharityIssueCategoryCreatePage from "./charity-issue-category-create-page";
import CharityIssueCategoryEditPage from "./charity-issue-category-edit-page";
 

export default (
  <Route path="charity-issue-categories">
    <Route
      index
      element={
        <Protected
          path="/admin/charity-issue-categories"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityIssueCategoriesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/charity-issue-categories/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityIssueCategoryCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/charity-issue-categories/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityIssueCategoryEditPage />
        </Protected>
      }
    />  
  </Route>
);
